import { Fragment } from "react";
import { norm, openLink, getGameStates, getBettingData, getLeagueContainer, getGridClass } from "../../../../functions/functions.js";
import { useLeagueToggle } from "../../../../hooks/useLeagueToggle.js";
import SecondaryTitle from "../reusablesComponent/subtitle.js";
import EquiposGeneralComponent from "./teamsGeneral.js";
import FooterCard from "../reusablesComponent/footerCard.js";
import MomiosFutComponent from "./momiosFut.js";
import BotonApostarHub from "../reusablesComponent/buttonApostar.js";

/**
 * Componente principal para mostrar tarjetas de deportes generales
 * Renderiza ligas con sus respectivos juegos, incluyendo equipos, puntajes y momios
 * Soporta múltiples casas de apuestas (Strendus/Caliente) y estados de juego
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.leagues - Array de ligas con sus juegos
 * @param {boolean} props.mostrarMomios - Controla la visibilidad de los momios
 * @param {string} props.url - URL base para imágenes de equipos
 * @param {boolean} props.mostrarBotonApostar - Controla la visibilidad del botón de apuestas
 * @param {boolean} props.isStrendus - Determina qué casa de apuestas usar
 * 
 * @returns {JSX.Element} Componente con tarjetas de juegos deportivos
 */
export default function CardGeneral({
  leagues = [],
  mostrarMomios,
  url = "/assets/",
  mostrarBotonApostar = true,
  isStrendus = false,
  selectedLeague = null
}) {

  // Hook para manejar el estado de expansión/colapso de ligas
  const { openMap } = useLeagueToggle(leagues);

  return (
    <>
      {leagues.map((league, leagueIdx) => {
        const { contId, id, visible, key } = getLeagueContainer(league, leagueIdx, openMap);

        return (
          <div key={key} className={`${getGridClass(league.games?.length)}`}>
            {/* Título de la liga con funcionalidad de toggle */}
            <SecondaryTitle
              leagueName={league.name}
              isVisible={visible}
              isFiltered={!!selectedLeague}
              linkLiga={league.url}
              leagueImage={league.image}
              sport={"FOOT"}
            />

            {/* Contenedor de juegos de la liga */}
            <div
              id={contId}
              className={`content-list-cards content-foot-soccer`}
              style={{ display: "grid" }}
            >
              {Array.isArray(league.games) &&
                league.games.map((item, gameIdx) => {
                  // Funciones utilitarias para extraer lógica repetida
                  const { time_format, cls: gameClass, isNextOrError, isFinished, isError: isErrorGame } = getGameStates(item);
                  const { hasMm, apostarHref } = getBettingData(item, isStrendus);

                  // Destructuring para datos específicos del deporte general
                  const { period_title, opta_event_url, venue_name, venue_country, venue_state } = item;

                  /**
                   * Configuración de clases CSS dinámicas según el estado del juego
                   * Ajusta el layout cuando no hay momios disponibles
                   */
                  const leftBlockClasses = ["card-body-general-players"];
                  const rightBlockClasses = ["card-body-general-scores"];

                  // Banderas para mostrar elementos
                  const shouldShowButton = mostrarBotonApostar === 'true' && !isFinished && !isErrorGame;
                  const shouldMomios = mostrarMomios === true && !isFinished && !isErrorGame;

                  return (
                    <div key={gameIdx} className={`card-complete-event`}>
                      <div className="card-game">

                        {/* BODY - Contenido principal del juego */}
                        <div className="card-body-general" onClick={() => openLink(opta_event_url, true)}>

                          {/* SECCIÓN MOMIOS - Solo si están habilitados y hay datos válidos */}
                          {shouldMomios && hasMm ? (
                            <MomiosFutComponent
                              isFinOrError={isErrorGame || isFinished}
                              item={item}
                              isStrendus={isStrendus}
                            />)
                            : <div className="card-general-momios-visible"></div>
                          }

                          {/* SECCIÓN IZQUIERDA - Equipos */}
                          <EquiposGeneralComponent
                            item={item} url={url} leftBlockClasses={leftBlockClasses}
                            rightBlockClasses={rightBlockClasses}
                            norm={norm}
                            gameClass={gameClass}
                            isErrorGame={isErrorGame}

                            time_format={time_format}
                            isTenis={false}
                            tenis_fase=""
                          />

                        </div>

                        {shouldShowButton &&
                          <BotonApostarHub
                            mostrarBotonApostarCard={shouldShowButton}
                            isStrendus={isStrendus}
                            apostarHref={apostarHref}
                          />
                        }

                        {/* FOOTER - Información del venue */}
                        <FooterCard
                          estadio={venue_name}
                          ciudad={venue_state}
                          estado={venue_country}
                          opta_event_url={opta_event_url}
                          clase={item.class}
                          period_title={period_title}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </>
  );
}